// Vendors
import $ from 'jquery';

function stopAllYouTubeVideos() {
  let iframes = document.querySelectorAll('iframe');
  Array.prototype.forEach.call(iframes, (iframe) => {
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: 'stopVideo' }),
      '*'
    );
  });
}

// function to stop video from playing on modal button close
$('.modal__close').on('click', (event) => {
  event.preventDefault();
  stopAllYouTubeVideos();
});

// function to stop video from playing when clicking outside modal
$('.modal').on('click', (event) => {
  event.preventDefault();
  stopAllYouTubeVideos();
});
